import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearRedeemRulesOptions,
  GetSchemasSuccess,
  SearchRedeemRulesSuccess,
  SelectedSchemaChanged,
} from '../actions/search.actions';
import { RedeemRulesSearchState } from '../models/redeem-rules.model';

const initialState: RedeemRulesSearchState = {
  schemas: [],
  selectedSchema: '',
  panelExpanded: true,
  lastSearchResponse: null,
};

export const RedeemRulesSearchReducer = createReducer(
  initialState,
  on(GetSchemasSuccess, (state, { res }) => ({
    ...state,
    schemas: res,
  })),
  on(SelectedSchemaChanged, (state, { selectedSchema }) => ({
    ...state,
    selectedSchema,
  })),
  on(SearchRedeemRulesSuccess, (state, { res }) => ({
    ...state,
    lastSearchResponse: res,
  })),
  on(ClearRedeemRulesOptions, (state) => ({
    ...state,
    selectedSchema: '',
    lastSearchResponse: null,
  })),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
